/*!
  Pioneer WFRIA IconInformationalLight v4.0.0-beta.53
  © 2023 Wells Fargo. All rights reserved.
*/
try {
  if (!window.__PIONEER_GLOBAL__) {
    window.__PIONEER_GLOBAL__ = {
      version: "4.0.0-beta.53",
      components: ["IconInformationalLight"]
    };
  } else if (window.__PIONEER_GLOBAL__.components && window.__PIONEER_GLOBAL__.components.indexOf("IconInformationalLight") < 0) {
    window.__PIONEER_GLOBAL__.components.push("IconInformationalLight");
  }
} catch (error) {
  // catching server side rendering issues - windows is not defined there!
}

import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * This file was automatically generated.
 * Please do not edit manually.
 *
 * For details, please refer to the src/Icons/README.md file
 */
import React from "react";
import IconLoader from "../private/IconLoader/IconLoader";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";

function Icon(props) {
  return _jsx(IconLoader, _objectSpread(_objectSpread({}, props), {}, {
    iconName: "IconInformationalLight"
  }));
}

Icon.displayName = "IconInformationalLight";
export default Icon;